module.exports = __webpack_public_path__ + "static/img/phone.ec5493ad.png";